import { getPersistentStoreValue, PersistentStore, setPersistentStoreValue } from 'store/PersistentStore';
import { authenticate, validate } from 'api/betreuer';
import store from '../index';
import { Auth, AuthAction, AuthActionPayload, AuthActionType, defaultAuth } from './types';
import { lookupsInitialize } from '../lookups/actions';

function requestAuthAction(): AuthAction {
    return { type: AuthActionType.REQUEST_AUTH };
}

function requestAuthValidateAction(): AuthAction {
    return { type: AuthActionType.REQUEST_AUTH_VALIDATE };
}

function receiveAuthLoginAction(payload: AuthActionPayload): AuthAction {
    return { type: AuthActionType.RECEIVE_AUTH_LOGIN, payload };
}

function receiveAuthLogoutAction(payload: AuthActionPayload): AuthAction {
    return { type: AuthActionType.RECEIVE_AUTH_LOGOUT, payload };
}

export async function validateAuth(): Promise<void> {
    store.dispatch(requestAuthValidateAction());

    const auth = await validate();

    setPersistentStoreValue(PersistentStore.auth, auth);

    if (auth.isAuthenticated) {
        store.dispatch(receiveAuthLoginAction({ success: true, auth }));
        lookupsInitialize();
    } else {
        store.dispatch(
            receiveAuthLoginAction({
                success: false,
                auth: {
                    error: 'Benutzername oder Passwort ungültig.',
                },
            }),
        );
    }
}

export async function login(mail: string, password: string): Promise<void> {
    store.dispatch(requestAuthAction());

    const auth = await authenticate(mail, password);

    setPersistentStoreValue(PersistentStore.auth, auth);

    if (auth.isAuthenticated) {
        store.dispatch(receiveAuthLoginAction({ success: true, auth }));
        lookupsInitialize();
    } else {
        store.dispatch(
            receiveAuthLoginAction({
                success: false,
                auth: {
                    error: 'Benutzername oder Passwort ungültig.',
                },
            }),
        );
    }
}

export async function logout(): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, 300));

    const storedAuth: Auth = getPersistentStoreValue(PersistentStore.auth) as Auth;

    const auth = {
        isAuthenticated: false,
        nr: storedAuth.nr,
        mail: storedAuth.mail,
        name: storedAuth.name,
        kz: storedAuth.kz,
        rolle: storedAuth.rolle,
    };

    setPersistentStoreValue(PersistentStore.auth, auth);

    store.dispatch(receiveAuthLogoutAction({ success: true, auth }));
}

export async function removePersistedUser(): Promise<void> {
    setPersistentStoreValue(PersistentStore.auth, defaultAuth);

    store.dispatch(receiveAuthLoginAction({ success: true, auth: defaultAuth }));
}

export function authInitialize(): void {
    const auth: Auth = getPersistentStoreValue(PersistentStore.auth, defaultAuth) as Auth;

    if (auth.isAuthenticated) {
        lookupsInitialize();
    }

    store.dispatch(receiveAuthLoginAction({ success: true, auth }));
}
